import Model from './Model'
import moment from "moment/moment";

export default class ToolboxTalkLibraryItem extends Model {
    static async all() {
        const data = await Http.get(route('api.v2.hsqe.toolbox-talk-library-items.list'), {})
        return this.make(data)
    }

    getDownloadUrl() {
        return route('api.v2.hsqe.toolbox-talk-library-items.pdf', [this.id])
    }

    getPrintableUrl() {
        return route('api.v2.hsqe.toolbox-talk-library-items.download', [this.id])
    }

    setAttributes(attributes) {
        super.setAttributes(attributes);
        let tokens = [
            attributes.title,
            attributes.reference,
            attributes.createdBy,
        ]
        this.createdAt = moment(this.createdOn);
        if (this.lastUpdatedOn) {
            this.lastUpdatedAt = moment(this.lastUpdatedOn);
        }
        this.tokens = tokens.join('|').toLowerCase();
    }

    static async create(id, attributes = {}) {
        const success = await Http.post(route('api.v2.hsqe.toolbox-talk-library-items.create', [id]), attributes);
        const data = await Http.get(route('api.v2.hsqe.toolbox-talk-library-items', [id]))
        return this.make(data)
    }
    async update(attributes = {}) {
        const url = route('api.v2.hsqe.toolbox-talk-library-items.store', [this.id])
        const payload = this.constructor.parseAttributes({...this.getFormAttributes(), ...attributes})
        const success = await Http.put(url, payload)
        const data = await Http.get(route('api.v2.hsqe.toolbox-talk-library-items', [this.id]))
        return this.fill(data)
    }

    async delete() {
        await Http.delete(route('api.v2.hsqe.toolbox-talk-library-items.delete', this.id))
    }

    toDropdown() {
        return { label: this.reference + ' - ' + this.title, value: this.id }
    }

}
